import { Flex, Text, FlexProps, Link } from '@opendoor/bricks/core';
import Tooltip from './Tooltip';

export const DescriptionList: React.FC = ({ children }) => {
  return (
    <Flex
      as="dl"
      my={0}
      flexWrap="wrap"
      justifyContent="space-between"
      style={{
        columnGap: '1rem',
      }}
    >
      {children}
    </Flex>
  );
};

export const DescriptionItem: React.FC<
  FlexProps & {
    label: string;
    value?: string | number | null;
    tooltipContent?: string;
    linkContent?: string;
    handleOnClick?: () => void;
  }
> = ({ label, value, flex = '1 1 1', tooltipContent, linkContent, handleOnClick, ...props }) => {
  if (!value) {
    return null;
  }
  return (
    <Flex flexDirection="column" flex={flex} {...props}>
      <Text as="dt" mb="3" color="neutrals90">
        {label}
      </Text>
      {linkContent && (
        <Link
          analyticsName="cosmos-buyers-commission-modal-link"
          aria-label="Buyer's agent commission description"
          onClick={handleOnClick}
          fontSize="s0"
        >
          {linkContent}
        </Link>
      )}
      <Text as="dd" ml="0" fontWeight="semibold">
        {value}
        {tooltipContent && <Tooltip analyticsName="More about HOA">{tooltipContent}</Tooltip>}
      </Text>
    </Flex>
  );
};
